import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import image_background from "../../../assets/img/2.jpg";
function MissionVission() {
  return (
    <section
      id="featured-official"
      className="featured-official-section position-relative text-white"
    >
      {/* Background Image */}
      <img
                                    loading="lazy"
                                    decoding="async"
        src={image_background}
        alt="Background"
        className="position-absolute top-0 start-0 w-100 h-100 bg-cover"
        style={{ objectFit: "cover", zIndex: 0 }}
      />

      {/* Overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100 bggreen-trans"
        style={{ zIndex: 1 }}
      ></div>

      {/* Foreground Content */}
      <div
        className="container-fluid px-0 position-relative"
        style={{ zIndex: 2 }}
      >
        <div
          className="row align-items-center justify-content-center text-center text-lg-start gx-lg-3 gy-4"
          style={{ minHeight: "40vh" }}
        >
          <div className="row">
            <div className="col-lg-8 d-flex text-left p-5">
              <div className="textControler">
                <h1 className="text-light">
                  <strong>TRANSFORMATION</strong>
                </h1>

                <h2 className="text-light">
                  Building Sustainable Communities Through Housing and Urban
                  Development
                </h2>

                <h3
                  className="text-light fw-light mb-1"
                  style={{ lineHeight: "1.8", fontSize: "1.2em" }}
                >
                  The Federal Ministry of Housing and Urban Development is
                  committed to providing affordable housing, promoting
                  sustainable urban planning, and delivering modern
                  infrastructure that improves the quality of life for all
                  Nigerians. Through strategic policies, innovative housing
                  programs, urban renewal projects, and public-private
                  partnerships, the Ministry drives national development by
                  creating inclusive, resilient, and well-planned communities.
                  With a focus on accessibility, transparency, and long-term
                  growth, the Ministry remains dedicated to shaping safer cities
                  and better living environments across the nation.
                </h3>
              </div>
            </div>

            {/* <div className="col-lg-6 d-flex text-center align-items-center p-5">
              <div>
                <h2 className="text-light">MANDATE STATEMENT</h2>
                <h5 className="text-light fw-light mb-1">
                  To formulate and implement the policies, programmes and
                  projects of the Federal Government of Nigeria (FGN) with
                  respect to:Habitat and affordable housing for Nigerians and
                  Driving economic diversity growth and development through
                  continuous and incremental provision of affordable housing
                  across the country and to focus on the key areas of
                  deliverables set for it.
                </h5>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default MissionVission;
